"use client";

import { importTargetsCsv } from "@/app/actions";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRouter } from "next/navigation";
import { useState } from "react";

export function TargetImport() {
  const router = useRouter();
  const [message, setMessage] = useState("");

  return (
    <Card>
      <CardContent>
        <form
          className="flex flex-wrap items-end gap-3"
          action={async (formData) => {
            const file = formData.get("file") as File | null;
            const text = file ? await file.text() : "";
            const result = await importTargetsCsv(text);
            setMessage(`${result.count} suspects imported.`);
            router.refresh();
          }}
        >
          <div>
            <p className="mb-2 text-xs text-[var(--text-muted)]">
              Import from CSV
            </p>
            <input
              type="file"
              name="file"
              accept=".csv,text/csv"
              className="text-sm"
              required
            />
            <p className="mt-1 text-xs text-[var(--text-faint)]">
              columns: domain, url, notes, priority, tags
            </p>
          </div>
          <Button type="submit" variant="secondary">
            Import
          </Button>
          {message ? <p className="text-sm text-[var(--text-muted)]">{message}</p> : null}
        </form>
      </CardContent>
    </Card>
  );
}
